const stateUser = {
    nameState: 'State global user',
    user:null,
    user_retrive:null,
}

export default stateUser;